// Cal meets people at the door — and reacts to them.
//
// No glass chip around the copy any more (it read as UI, not as a voice):
// the welcome is set directly on the backdrop, and under it one line at a
// time shows what caloly actually does — a rotating showcase, so a person
// who has never seen the app learns photo / voice / adaptive coaching in
// three glances without the screen being packed.
//
// Cal is poked, it hops. A password field is focused, it covers its eyes.
// Delight and privacy in one gesture; nothing here is load-bearing.
import { useEffect, useState } from "react";
import { Mascot } from "./Mascot";
import { useT } from "../lib/i18n";
import { hapticTap } from "../lib/haptics";

const FEATURES = ["auth.feat_photo", "auth.feat_voice", "auth.feat_coach"] as const;
const ROTATE_MS = 3600;

export function AuthHero({ line, peeking = false }: { line: string; peeking?: boolean }) {
  const t = useT();
  const [poked, setPoked] = useState(false);
  const [feat, setFeat] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setFeat((f) => (f + 1) % FEATURES.length), ROTATE_MS);
    return () => clearInterval(id);
  }, []);

  const poke = () => {
    hapticTap();
    setPoked(true);
    setTimeout(() => setPoked(false), 950);
  };

  const pose = peeking ? "peeking" : poked ? "celebrating" : "greeting";
  return (
    <div className="flex flex-col items-center mb-6 select-none text-center">
      <button type="button" tabIndex={-1} aria-hidden="true" onPointerDown={poke} className="press">
        <Mascot pose={pose} size={108} />
      </button>
      <p className="mt-3 text-base font-semibold text-fg">{line}</p>
      {/* key change re-runs the enter animation — one feature at a time */}
      <p key={feat} className="auth-feature mt-1.5 text-sm text-fg-muted min-h-[1.5rem]">
        {t(FEATURES[feat])}
      </p>
    </div>
  );
}
